/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { ProcessingErrorCodeHelper } from "../constants/processing-error-codes.constants";
import {
  ChargifyCoupon,
  ChargifyProduct,
  ChargifyStatement,
  ChargifySubscription,
  QPilotIntegration,
  SiteSubscriptionData,
  SiteFull,
} from "../models/site.interface";
import {
  ChangePasswordRequest,
  UserProfileContact,
} from "../../features/account/interfaces/profile.interface";
import { Page } from "../../features/widgets/sidebar/sidebar-menu.interface";
import { QPilotSecretKey } from "../../features/apps/pages/components/api-key-list/api-key-list.component";
import { QPilotSubscriptionPaymentMethod } from "../../features/account/pages/change-plan/change-plan.component";
import { CustomerPortalSiteSettings } from "../../features/settings/interfaces/customer-portal-settings.interface";
import {
  ISiteEmailSettings,
  IScheduledOrderDaysNotification,
  IEmailTemplateSetting,
  IEmailTemplateStyleSettings,
} from "../../features/settings/interfaces/email-settings.interface";
import { DunningSettings } from "../../features/settings/interfaces/dunning-settings.interface";
import { SiteEmailSettings } from "../../features/settings/interfaces/site-email-settings.interface";
import {
  IEmailTemplate,
  EmailTemplateType,
  ITemplatePreviewData,
  ITemplateVariable,
  IValidationResult,
} from "../../features/settings/interfaces/email-template.interface";
import {
  EmailPreviewDto,
  EmailPreviewRequest,
  MessageType,
} from "../../features/settings/interfaces/email-preview.interface";
import { ScheduledOrderCounts } from "../../features/scheduled-orders/interfaces/scheduled-orders-counts.interface";
import { ScheduledOrdersFilter } from "../../features/scheduled-orders/interfaces/scheduled-orders-filter.interface";
import {
  BulkSOActionsResponse,
  PagedResult,
  ScheduledOrderListItem,
  ValidationResult,
} from "../../features/scheduled-orders/interfaces/scheduled-orders-list-item.interface";
import { ProcessingCycleListResponse } from "../../features/scheduled-orders/interfaces/processing-cycle.interface";
import { ScheduledOrder } from "../models/scheduled-order.interface";
import { ScheduledOrderTotals } from "../models/scheduled-order-totals.interface";
import { ScheduledOrderCoupon } from "../models/scheduled-order-coupon.interface";
import { ScheduledOrderShippingRateOption } from "../models/scheduled-order-shipping-rate-option.interface";
import { NextimeSiteIdResponse } from "../models/nextime-site-id-response.interface";
import { SubPage } from "../models/sub-page.interface";
import { SiteTier } from "../models/site-tier.interface";
import { SiteSettings } from "../models/site-settings.interface";
import {
  QPilotPaymentMethod,
  PaymentIntegrationsResponse,
} from "../models/qpilot/payment-method.interface";
import { QPilotProduct } from "../models/qpilot/product.interface";

/**
 * Interface for Secret Key
 */

/**
 * Interface for Create Secret Key Request
 */
export interface QPilotCreateSecretKeyRequest {
  Description: string;
  Type: string;
  IntegrationId: number;
}

/**
 * Interface for Site
 */
export interface Site {
  Id: number;
  Name?: string;
  Url?: string;
}

/**
 * Interface for Site Integration
 */
export interface QPilotSiteIntegration {
  siteId: number;
  site?: Site;
  integrationId: number;
  integration?: QPilotIntegration;
  outboundApiKey1?: string;
  outboundApiKey2?: string;
  inboundApiKey?: string;
  testMode?: boolean;
  enabled?: boolean;
}

/**
 * Interface for Post/Put Site Integration
 */
export interface QPilotPostPutSiteIntegration {
  siteId: number;
  integrationId: number;
  outboundApiKey1?: string;
  outboundApiKey2?: string;
  liveMode?: boolean;
  enabled?: boolean;
}

/**
 * Interface for the QPilot user
 */
export interface QPilotUser {
  Id: number;
  UserId: number;
  Email: string;
  Role: string;
  SubscriptionId: string;
  SubscriptionStatus: string;
  SubscriptionPaymentMethodDescription: string;
  SubscriptionUpdatedUtc?: Date;

  ChargifyProductHandle: string;
  ActiveTier: string;

  CreatedUtc: Date;
  UpdatedUtc: Date;

  FirstLogin: number;

  EmailVerificationStatus: "Verified" | "PendingVerification";
}

/**
 * Interface for Security Token Request
 */
export interface SecurityTokenRequest {
  RecaptchaToken: string;
}

/**
 * Interface for Security Token Response
 */
export interface SecurityTokenResponse {
  Token: string;
}

/**
 * Interface for the access token response
 */
export interface QPilotAccessToken {
  Id: number;
  UserId: number;
  TokenAuth: string;
  TokenBearerAuth: string;
  CreatedUtc: Date;
  UpdatedUtc: Date;
  ExpiresUtc: Date;
  User: QPilotUser;
  FirstLogin: number;
}

/**
 * Interface for login credentials
 */
export interface LoginCredentials {
  Email: string;
  Password: string;
  EmailVerificationToken?: string;
  AccessScope: string;
}

/**
 * Interface for Site Resume Check Response
 */
export interface QPilotSiteResumeCheckViewModel {
  Immediate: number;
  Tomorrow: number;
}

/**
 * Interface for Product Summary - matches old QMC QPilotProductSummary
 * Used in product list views
 */
export interface ProductSummary {
  Id: number;
  ParentProductId?: number;
  ExternalId: string;
  ProductName?: string;
  Availability: string;
  ProductType?: string;
  ShippingClass?: string | null;
  QuantityScheduled?: number;
  StockLevel: string;
  TotalQuantityScheduledActive?: number;
  TotalQuantityScheduledPaused?: number;
  TotalQuantityFailed?: number;
  TotalQuantityProcessing?: number;
  TotalQuantityQueued?: number;
  LifetimeValue?: number;
  Stock?: number;
  Active: boolean;
  Valid?: boolean;
  ValidationErrorCode?: string | null;
  UpdatedUtc?: string;
}

/**
 * Interface for Product Summaries Count - matches old QMC QPilotProductSummariesCount
 */
export interface ProductSummariesCount {
  Count: number;
  InactiveProductsCount: number;
  InvalidProductsCount: number;
}

/**
 * Interface for Product Group - matches old QMC QPilotProductGroup
 */
export interface ProductGroup {
  ProductGroupId: number;
  Name: string;
  SiteId: number;
  Products?: ProductGroupProduct[];
  CreatedUtc?: string;
  UpdatedUtc?: string;
}

/**
 * Interface for Product Group Product
 * For create/update - Id (ExternalId) and Title are required
 * API may return additional fields
 */
export interface ProductGroupProduct {
  Id: string; // Product ExternalId (required for create/update)
  Title: string; // Product title (required for display)
  ProductGroupProductId?: number;
  ProductGroupId?: number;
  ProductId?: number;
  ProductExternalId?: string;
}

/**
 * Interface for Product Summary Update Response
 * Can return either the updated product or an error message
 */
export interface ProductSummaryUpdateResponse {
  // Success case - returns the updated product fields
  Id?: number;
  ParentProductId?: number;
  ExternalId?: string;
  ProductName?: string;
  Availability?: string;
  ProductType?: string;
  ShippingClass?: string;
  StockLevel?: string;
  Active?: boolean;
  Valid?: boolean;
  ValidationErrorCode?: string | null;
  // Error case - returns message and original product
  Message?: string;
  productSummary?: ProductSummary;
}

/**
 * Response from Products/BatchUpdate endpoint
 */
export interface ProductBatchUpdateResponse {
  Success?: boolean;
  Message?: string;
  UpdatedCount?: number;
  FailedCount?: number;
  FailedIds?: string[];
}

/**
 * Service for communicating with the QPilot API
 */
@Injectable({
  providedIn: "root",
})
export class QPilotService {
  private readonly qpilotUrl: string = environment.qpilotApiUrl + "/api";
  private readonly newQpilotUrl: string = environment.qpilotApiUrl;
  private readonly qpilotNonCoreApiUrl: string =
    environment.qpilotNonCoreApiUrl;

  constructor(private readonly http: HttpClient) {}

  /**
   * Performs a POST request to the QPilot API
   * @param url The URL to send the request to
   * @param data The data to send in the request body
   * @param accessToken Optional access token for authenticated requests
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable with the response
   */
  private httpPost<TIn, TOut>(
    url: string,
    data: TIn,
    accessToken?: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<TOut> {
    let headers = this.createHeaders(accessToken);
    const loaderHeaders = showGlobalLoader
      ? this.getLoaderHeaders()
      : this.getNoLoaderHeaders();
    if (loaderHeaders) {
      loaderHeaders.keys().forEach((key: string) => {
        const value = loaderHeaders.get(key);
        if (value !== null) {
          headers = headers.set(key, value);
        }
      });
    }
    return this.http.post<TOut>(url, data, { headers });
  }

  /**
   * Performs a GET request to the QPilot API
   * @param url The URL to send the request to
   * @param accessToken Optional access token for authenticated requests
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable with the response
   */
  private httpGet<TOut>(
    url: string,
    accessToken?: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<TOut> {
    let headers = this.createHeaders(accessToken);
    const loaderHeaders = showGlobalLoader
      ? this.getLoaderHeaders()
      : this.getNoLoaderHeaders();
    if (loaderHeaders) {
      loaderHeaders.keys().forEach((key: string) => {
        const value = loaderHeaders.get(key);
        if (value !== null) {
          headers = headers.set(key, value);
        }
      });
    }
    return this.http.get<TOut>(url, { headers });
  }

  /**
   * Performs a PUT request to the QPilot API
   * @param url The URL to send the request to
   * @param data The data to send in the request body
   * @param accessToken Optional access token for authenticated requests
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable with the response
   */
  private httpPut<TIn, TOut>(
    url: string,
    data: TIn,
    accessToken?: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<TOut> {
    let headers = this.createHeaders(accessToken);
    const loaderHeaders = showGlobalLoader
      ? this.getLoaderHeaders()
      : this.getNoLoaderHeaders();
    if (loaderHeaders) {
      loaderHeaders.keys().forEach((key: string) => {
        const value = loaderHeaders.get(key);
        if (value !== null) {
          headers = headers.set(key, value);
        }
      });
    }
    return this.http.put<TOut>(url, data, { headers });
  }

  /**
   * Performs a DELETE request to the QPilot API
   * @param url The URL to send the request to
   * @param accessToken Optional access token for authenticated requests
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable with the response
   */
  private httpDelete<TOut>(
    url: string,
    accessToken?: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<TOut> {
    let headers = this.createHeaders(accessToken);
    const loaderHeaders = showGlobalLoader
      ? this.getLoaderHeaders()
      : this.getNoLoaderHeaders();
    if (loaderHeaders) {
      loaderHeaders.keys().forEach((key: string) => {
        const value = loaderHeaders.get(key);
        if (value !== null) {
          headers = headers.set(key, value);
        }
      });
    }
    return this.http.delete<TOut>(url, { headers });
  }

  /**
   * Creates headers for the HTTP requests
   * @param accessToken Optional access token for authenticated requests
   * @returns HTTP headers
   */
  private createHeaders(accessToken?: QPilotAccessToken): HttpHeaders {
    let headers = new HttpHeaders();

    if (accessToken) {
      if (accessToken.TokenBearerAuth) {
        headers = headers.set(
          "Authorization",
          `Bearer ${accessToken.TokenBearerAuth}`,
        );
      } else if (accessToken.TokenAuth) {
        headers = headers.set(
          "Authorization",
          `Basic ${accessToken.TokenAuth}`,
        );
      }
    }

    return headers;
  }

  /**
   * Returns headers with X-Show-Global-Loader for requests that should show the global loader
   */
  private getLoaderHeaders(): HttpHeaders {
    return new HttpHeaders({ "X-Show-Global-Loader": "true" });
  }

  /**
   * Returns undefined for requests that should not show the global loader
   */
  private getNoLoaderHeaders(): undefined {
    return undefined;
  }

  /**
   * Creates an access token (login)
   * @param email User email
   * @param password User password
   * @param emailVerificationToken Optional email verification token
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable with the access token
   */
  public createAccessToken(
    email: string,
    password: string,
    emailVerificationToken: string | undefined = undefined,
  ): Observable<QPilotAccessToken> {
    const endpoint = this.qpilotUrl + "/AccessTokens/Login";
    const credentials: LoginCredentials = {
      Email: email,
      Password: password,
      EmailVerificationToken: emailVerificationToken,
      AccessScope: "Merchant",
    };
    return this.httpPost<LoginCredentials, QPilotAccessToken>(
      endpoint,
      credentials,
    );
  }

  /**
   * Initiates a password reset process for the specified email address.
   *
   * Sends a POST request to the Qpilot API to trigger a password reset email
   * for the user associated with the provided email address.
   *
   * @param email - The email address of the user requesting a password reset.
   * @returns An Observable that completes when the request is successful.
   */
  public resetPassword(email: string): Observable<null> {
    const endpoint =
      this.qpilotUrl +
      "/Users/ResetPassword?email=" +
      encodeURIComponent(email);
    return this.httpPost<null, null>(endpoint, null);
  }

  /**
   * Resends the email verification link for the specified email address
   * @param email The email address to resend the verification link to
   * @returns Observable that completes when the request is successful
   */
  public resendValidationEmail(email: string): Observable<null> {
    const endpoint = this.qpilotUrl + "/Users/ResendValidationEmail";
    const payload = { Email: email };
    return this.httpPost<{ Email: string }, null>(endpoint, payload);
  }

  /**
   * Registers a new user
   * @param email User email
   * @param password User password
   * @param recaptchaToken reCAPTCHA token
   * @param accountOwnerEmail Optional account owner email
   * @param accountOwnerPhoneNumber Optional account owner phone number
   * @returns Observable with the registered user
   */
  public registerUser(
    email: string,
    password: string,
    recaptchaToken: string,
    accountOwnerEmail?: string,
    accountOwnerPhoneNumber?: string,
  ): Observable<QPilotUser> {
    const endpoint = this.qpilotUrl + "/Users/Register";
    const credentials = {
      Email: email,
      Password: password,
      RecaptchaToken: recaptchaToken,
      AccountOwnerEmail: accountOwnerEmail,
      AccountOwnerPhoneNumber: accountOwnerPhoneNumber,
    };
    return this.httpPost<typeof credentials, QPilotUser>(endpoint, credentials);
  }

  /**
   * Gets the user by ID
   * @param userId User ID
   * @param accessToken Access token
   * @returns Observable with the user
   */
  public getUser(
    userId: number,
    accessToken: QPilotAccessToken,
  ): Observable<QPilotUser> {
    const endpoint = this.qpilotUrl + "/Users/" + userId.toString();
    return this.httpGet<QPilotUser>(endpoint, accessToken);
  }

  /**
   * Updates a user
   * @param user User to update
   * @param accessToken Access token
   * @returns Observable with the updated user
   */
  public updateUser(
    user: QPilotUser,
    accessToken: QPilotAccessToken,
  ): Observable<QPilotUser> {
    const endpoint = this.qpilotUrl + "/Users/UpdateUser";
    return this.httpPut<QPilotUser, QPilotUser>(endpoint, user, accessToken);
  }

  /**
   * Gets the subscription for a user
   * @param userId User ID
   * @param accessToken Access token
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable with the subscription
   */
  public getSubscription(
    userId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ChargifySubscription> {
    const endpoint = this.qpilotUrl + "/Users/" + userId + "/Subscription";
    return this.httpGet<ChargifySubscription>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Gets all integrations
   * @param accessToken Access token
   * @returns Observable with the integrations
   */
  public getAllIntegrations(
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<QPilotIntegration[]> {
    const endpoint = `${this.newQpilotUrl}/Integrations/All`;
    return this.httpGet<QPilotIntegration[]>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Gets all integrations with a specific category
   * @param accessToken Access token
   * @param category Integration category
   * @returns Observable with the integrations
   */
  getIntegration(
    accessToken: QPilotAccessToken,
    id: number,
    showGlobalLoader: boolean = false,
  ): Observable<QPilotIntegration> {
    return this.httpGet<QPilotIntegration>(
      `${this.newQpilotUrl}/Integrations/${id}`,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Gets secret keys for an integration
   * @param accessToken Access token
   * @param integrationId Integration ID
   * @returns Observable with the secret keys
   */
  public getSecretKeys(
    accessToken: QPilotAccessToken,
    id: number,
  ): Observable<QPilotSecretKey[]> {
    const endpoint = `${this.qpilotUrl}/Integration/${id}`;
    return this.httpGet<QPilotSecretKey[]>(endpoint, accessToken);
  }

  /**
   * Gets secret keys for a user
   * @param accessToken Access token
   * @param userId User ID
   * @returns Observable with the secret keys
   */
  public getSecretKeysForUser(
    accessToken: QPilotAccessToken,
    userId: number,
    showGlobalLoader: boolean = false,
  ): Observable<QPilotSecretKey[]> {
    const endpoint = `${this.qpilotUrl}/SecretKeys/${userId}/SecretKeys`;
    return this.httpGet<QPilotSecretKey[]>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Creates a secret key
   * @param accessToken Access token
   * @param request Secret key request
   * @returns Observable with the created secret key
   */
  public createSecretKey(
    accessToken: QPilotAccessToken,
    request: QPilotCreateSecretKeyRequest,
    showGlobalLoader: boolean = false,
  ): Observable<QPilotSecretKey> {
    const endpoint = `${this.qpilotUrl}/SecretKeys`;
    return this.httpPost<QPilotCreateSecretKeyRequest, QPilotSecretKey>(
      endpoint,
      request,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Deletes a secret key
   * @param accessToken Access token
   * @param id Secret key ID
   * @returns Observable with the response
   */
  public deleteSecretKey(
    accessToken: QPilotAccessToken,
    id: number,
    showGlobalLoader: boolean = false,
  ): Observable<unknown> {
    const endpoint = `${this.qpilotUrl}/SecretKeys/${id}`;
    return this.httpDelete<unknown>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Gets all sites
   * @param accessToken Access token
   * @returns Observable with the sites
   */
  public getSites(
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<Site[]> {
    const endpoint = `${this.qpilotUrl}/Sites`;
    return this.httpGet<Site[]>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Gets basic site data by ID
   * @param siteId Site ID
   * @param accessToken Access token
   * @returns Observable with the basic site data
   */
  public getSite(
    siteId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<Site> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}`;
    return this.httpGet<Site>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Gets full site data by ID
   * @param siteId Site ID
   * @param accessToken Access token
   * @returns Observable with the full site data
   */
  public getSiteFull(
    siteId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<SiteFull> {
    const endpoint = `${this.qpilotUrl}/Sites/Full/${siteId}`;
    return this.httpGet<SiteFull>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Gets site integrations for an integration
   * @param accessToken Access token
   * @param integrationId Integration ID
   * @returns Observable with the site integrations
   */
  getSiteIntegrations(
    siteId: number,
    accessToken: QPilotAccessToken,
  ): Observable<QPilotSiteIntegration> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/Integrations`;
    return this.httpGet<QPilotSiteIntegration>(endpoint, accessToken);
  }

  /**
   * Gets all site integrations
   * @param accessToken Access token
   * @returns Observable with the site integrations
   */
  getSitesIntegrations(
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<QPilotSiteIntegration[]> {
    const endpoint = this.newQpilotUrl + "/SiteIntegrations";
    return this.httpGet<QPilotSiteIntegration[]>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Creates a site integration
   * @param accessToken Access token
   * @param siteIntegration Site integration
   * @returns Observable with the created site integration
   */
  public createSiteIntegration(
    accessToken: QPilotAccessToken,
    siteIntegration: QPilotPostPutSiteIntegration,
    showGlobalLoader: boolean = false,
  ): Observable<QPilotSiteIntegration> {
    const endpoint = `${this.newQpilotUrl}/SiteIntegrations`;
    return this.httpPost<QPilotPostPutSiteIntegration, QPilotSiteIntegration>(
      endpoint,
      siteIntegration,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Updates a site integration
   * @param accessToken Access token
   * @param siteIntegration Site integration
   * @returns Observable with the updated site integration
   */
  public updateSiteIntegration(
    accessToken: QPilotAccessToken,
    siteIntegration: QPilotPostPutSiteIntegration,
  ): Observable<QPilotSiteIntegration> {
    const endpoint = `${this.newQpilotUrl}/SiteIntegrations`;
    return this.httpPut<QPilotPostPutSiteIntegration, QPilotSiteIntegration>(
      endpoint,
      siteIntegration,
      accessToken,
    );
  }

  /**
   * Refreshes a site integration key
   * @param accessToken Access token
   * @param siteId Site ID
   * @param integrationId Integration ID
   * @returns Observable with the refreshed site integration
   */
  public refreshSiteIntegrationKey(
    accessToken: QPilotAccessToken,
    siteIntegration: QPilotPostPutSiteIntegration,
  ): Observable<QPilotSiteIntegration> {
    const endpoint = `${this.newQpilotUrl}/SiteIntegrations/RefreshInboundApiKey`;
    return this.httpPut<QPilotPostPutSiteIntegration, QPilotSiteIntegration>(
      endpoint,
      siteIntegration,
      accessToken,
    );
  }

  /**
   * Deletes a site integration
   * @param accessToken Access token
   * @param siteId Site ID
   * @param integrationId Integration ID
   * @returns Observable with the response
   */
  public deleteSiteIntegration(
    accessToken: QPilotAccessToken,
    siteId: number,
    integrationId: number,
  ): Observable<unknown> {
    const endpoint = `${this.newQpilotUrl}/SiteIntegrations/${siteId}/Integration/${integrationId}`;
    return this.httpDelete<unknown>(endpoint, accessToken);
  }

  /**
   * Gets sites subscription data
   * @param accessToken Access token
   * @returns Observable with the sites subscription data
   */
  public getSitesSubscriptionData(
    accessToken: QPilotAccessToken,
  ): Observable<SiteSubscriptionData[]> {
    const endpoint = this.qpilotUrl + "/Sites/Subscriptions";
    return this.httpGet<SiteSubscriptionData[]>(endpoint, accessToken);
  }

  /**
   * Gets the pages allowed for the current user
   * @param accessToken Access token
   * @returns Observable with the pages allowed
   */
  public getPagesAllowed(accessToken: QPilotAccessToken): Observable<string[]> {
    const endpoint = this.newQpilotUrl + "/UsersPermissions/PagesAllowed";
    return this.httpGet<string[]>(endpoint, accessToken);
  }

  /**
   * Formats a date for display
   * @param date Date to format
   * @returns Formatted date string
   */
  public formatSubscriptionDate(date: string): string {
    const dateObj = new Date(date);
    return dateObj.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  /**
   * Formats an image path
   * @param path Image path
   * @returns Formatted image path
   */
  public formatImagePath(path: string): string {
    // This is a placeholder for the actual implementation
    // In the original code, this was handled by a BlobStorageHelper
    return path;
  }

  /**
   * Checks if a subscription is active
   * @param subscription Subscription to check
   * @returns True if the subscription is active
   */
  public isSubscriptionActive(
    subscription: ChargifySubscription | null,
  ): boolean {
    // This is a placeholder for the actual implementation
    return subscription !== null;
  }

  /**
   * Checks if a subscription is inactive
   * @param subscription Subscription to check
   * @returns True if the subscription is inactive
   */
  public isSubscriptionInactive(
    subscription: ChargifySubscription | null,
  ): boolean {
    // This is a placeholder for the actual implementation
    return subscription === null;
  }
  /**
   * Gets the API version
   * @returns Observable with the API version
   */
  public getApiVersion(): Observable<string> {
    const endpoint = this.newQpilotUrl + "/VersionChecker/VersionNumber";
    return this.httpGet(endpoint);
  }

  /**
   * Gets the plan friendly name from a tier
   * @param subscription Subscription
   * @returns Plan friendly name
   */
  getPlanFriendlyNameFromTier(subscription: ChargifySubscription) {
    if (!subscription || !subscription.product) {
      return null;
    }

    if (subscription.product.handle === "tier-2") {
      return "Starter";
    } else if (subscription.product.handle === "tier-3") {
      return "Growth";
    } else if (subscription.product.handle === "tier-4") {
      return "Marketer";
    } else {
      return subscription.product.name;
    }
  }

  /**
   * Gets the Chargify products
   * @param accessToken Access token
   * @returns Observable with the Chargify products
   */
  public getChargifyProducts(
    accessToken: QPilotAccessToken,
  ): Observable<ChargifyProduct[]> {
    const endpoint = this.qpilotUrl + "/Chargify/Products";
    return this.httpGet<ChargifyProduct[]>(endpoint, accessToken);
  }

  /**
   * Validates a Chargify coupon code
   * @param couponCode Coupon code to validate
   * @param productId Product ID to validate against
   * @param accessToken Access token
   * @returns Observable with the validated coupon
   */
  public validateChargifyCouponCode(
    couponCode: string,
    productId: string,
    accessToken: QPilotAccessToken,
  ): Observable<ChargifyCoupon> {
    const endpoint =
      this.qpilotUrl +
      "/Chargify/ValidCoupons?code=" +
      encodeURIComponent(couponCode) +
      "&productId=" +
      encodeURIComponent(productId);
    return this.httpGet<ChargifyCoupon>(endpoint, accessToken);
  }

  /**
   * Gets the transaction history for a user
   * @param userId User ID
   * @param accessToken
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable with the transaction history
   */
  public getStatements(
    userId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ChargifyStatement[]> {
    const endpoint =
      this.qpilotUrl + "/Users/" + userId.toString() + "/Statements";
    return this.httpGet<ChargifyStatement[]>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Changes the password for a user
   * @param userId User ID
   * @param changePassword Change password request
   * @param accessToken Access token
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable that completes when the password is changed
   */
  public changePassword(
    userId: number,
    changePassword: ChangePasswordRequest,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<null> {
    const endpoint = this.qpilotUrl + "/Users/" + userId + "/ChangePassword";
    return this.httpPost<ChangePasswordRequest, null>(
      endpoint,
      changePassword,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Gets the user profile contact information
   * @param accessToken Access token
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable with the user profile contact information
   */
  public getUserProfileContact(
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<UserProfileContact> {
    const endpoint = this.qpilotUrl + "/UsersProfile";
    return this.httpGet<UserProfileContact>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Updates the user profile contact information
   * @param userProfileContact User profile contact information
   * @param accessToken Access token
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable that completes when the contact information is updated
   */
  public updateUserProfileContact(
    userProfileContact: UserProfileContact,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<null> {
    const endpoint = this.qpilotUrl + "/UsersProfile";
    return this.httpPost<UserProfileContact, null>(
      endpoint,
      userProfileContact,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Gets the pages for the sidebar menu
   * @param siteId Site ID
   * @param accessToken Access token
   * @returns Observable with the pages
   */
  public getPages(
    siteId: number,
    accessToken: QPilotAccessToken,
  ): Observable<Page[]> {
    return this.httpGet<Page[]>(
      this.newQpilotUrl + "/UsersPermissions/" + siteId,
      accessToken,
    );
  }

  /**
   * Gets the enabled feature flags for a site
   * @param siteId Site ID
   * @param accessToken Access token
   * @returns Observable with the enabled feature flags
   */
  public getSiteEnabledFeatureFlags(
    siteId: number,
    accessToken: QPilotAccessToken,
  ): Observable<string[]> {
    const endpoint = `${this.newQpilotUrl}/api/Sites/${siteId}/FeatureFlags`;
    return this.httpGet(endpoint, accessToken);
  }

  /**
   * Gets a security token for Chargify
   * @param accessToken Access token
   * @param recaptchaToken reCAPTCHA token
   * @returns Observable with the security token
   */
  public getSecurityToken(
    accessToken: QPilotAccessToken,
    recaptchaToken: string,
  ): Observable<SecurityTokenResponse> {
    const endpoint =
      this.qpilotUrl + "/Users/" + accessToken.UserId + "/SecurityToken";
    return this.httpPost<SecurityTokenRequest, SecurityTokenResponse>(
      endpoint,
      { RecaptchaToken: recaptchaToken },
      accessToken,
    );
  }

  /**
   * Validates a reCAPTCHA token
   * @param recaptchaToken reCAPTCHA token
   * @param accessToken Access token
   * @returns Observable with the validation result
   */
  public validateCaptcha(
    recaptchaToken: string,
    accessToken: QPilotAccessToken,
  ): Observable<boolean> {
    const endpoint = this.qpilotUrl + "/Users/ValidateCaptcha";
    const payload = {
      RecaptchaToken: recaptchaToken,
    };
    return this.httpPost<{ RecaptchaToken: string }, boolean>(
      endpoint,
      payload,
      accessToken,
    );
  }

  /**
   * Creates a new subscription for a user
   * @param userId User ID
   * @param subscriptionPaymentMethod Subscription payment method
   * @param accessToken Access token
   * @returns Observable with the created subscription
   */
  createSubscription(
    userId: number,
    subscriptionPaymentMethod: QPilotSubscriptionPaymentMethod,
    accessToken: QPilotAccessToken,
  ): Observable<ChargifySubscription> {
    const endpoint =
      this.qpilotUrl + "/Users/" + userId.toString() + "/Subscription";
    return this.httpPost<QPilotSubscriptionPaymentMethod, ChargifySubscription>(
      endpoint,
      subscriptionPaymentMethod,
      accessToken,
    );
  }

  /**
   * Updates an existing subscription for a user
   * @param userId User ID
   * @param subscriptionPaymentMethod Subscription payment method
   * @param accessToken Access token
   * @returns Observable with the updated subscription
   */
  updateSubscription(
    userId: number,
    subscriptionPaymentMethod: QPilotSubscriptionPaymentMethod,
    accessToken: QPilotAccessToken,
  ): Observable<ChargifySubscription> {
    const endpoint =
      this.qpilotUrl + "/Users/" + userId.toString() + "/Subscription";
    return this.httpPut<QPilotSubscriptionPaymentMethod, ChargifySubscription>(
      endpoint,
      subscriptionPaymentMethod,
      accessToken,
    );
  }

  /**
   * Deletes a site
   * @param site Site to delete
   * @param accessToken Access token
   * @returns Observable with the response
   */
  public deleteSite(
    site: Site,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<unknown> {
    const endpoint = this.qpilotUrl + "/Sites/" + site.Id;
    return this.httpDelete<unknown>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Pauses processing for a site
   * @param siteId Site ID
   * @param accessToken Access token
   * @returns Observable with the response
   */
  public pauseSite(
    siteId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<unknown> {
    const endpoint = this.qpilotUrl + "/Sites/" + siteId + "/Pause";
    return this.httpPut<null, unknown>(
      endpoint,
      null,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Resumes processing for a site
   * @param siteId Site ID
   * @param accessToken Access token
   * @returns Observable with the response
   */
  public resumeSite(
    siteId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<unknown> {
    const endpoint = this.qpilotUrl + "/Sites/" + siteId + "/resume";
    return this.httpPut<null, unknown>(
      endpoint,
      null,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Checks what orders will be processed if site is resumed
   * @param siteId Site ID
   * @param accessToken Access token
   * @returns Observable with the resume check response
   */
  public checkResumeSite(
    siteId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<QPilotSiteResumeCheckViewModel> {
    const endpoint = this.qpilotUrl + "/Sites/" + siteId + "/resume/check";
    return this.httpGet<QPilotSiteResumeCheckViewModel>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Edits a site (matches old QMC - sends full SiteFull object)
   * @param site Full site data
   * @param accessToken Access token
   * @returns Observable with the updated site
   */
  public editSite(
    site: SiteFull,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<SiteFull> {
    const endpoint = this.qpilotUrl + "/Sites/" + site.Id;
    return this.httpPut<SiteFull, SiteFull>(
      endpoint,
      site,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Gets customer portal site settings
   * @param siteId Site ID
   * @param accessToken Access token
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable with the customer portal site settings
   */
  public getCustomerPortalSiteSettings(
    siteId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<CustomerPortalSiteSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/CustomerPortalSettings`;
    return this.httpGet<CustomerPortalSiteSettings>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Updates customer portal site settings
   * @param siteId Site ID
   * @param settings Customer portal site settings
   * @param accessToken Access token
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable with the updated customer portal site settings
   */
  public editCustomerPortalSiteSettings(
    siteId: number,
    settings: CustomerPortalSiteSettings,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<CustomerPortalSiteSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/CustomerPortalSettings`;
    return this.httpPut<CustomerPortalSiteSettings, CustomerPortalSiteSettings>(
      endpoint,
      settings,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Gets site email settings
   * @param siteId Site ID
   * @param accessToken Access token
   * @returns Observable with site email settings
   */
  public getSiteEmailSettings(
    siteId: number,
    accessToken: QPilotAccessToken,
  ): Observable<SiteEmailSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailSettings`;
    return this.httpGet<SiteEmailSettings>(endpoint, accessToken);
  }

  /**
   * Updates site email settings
   * @param siteId Site ID
   * @param siteEmailSettings Email settings to update
   * @param accessToken Access token
   * @returns Observable with updated email settings
   */
  public updateSiteEmailSettings(
    siteId: number,
    siteEmailSettings: SiteEmailSettings,
    accessToken: QPilotAccessToken,
  ): Observable<SiteEmailSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailSettings`;
    return this.httpPut<SiteEmailSettings, SiteEmailSettings>(
      endpoint,
      siteEmailSettings,
      accessToken,
    );
  }

  /**
   * Updates email template style settings
   * @param siteId Site ID
   * @param siteEmailSettings Email settings containing style settings
   * @param accessToken Access token
   * @returns Observable with updated settings
   */
  public updateEmailTemplateStyleSettings(
    siteId: number,
    siteEmailSettings: ISiteEmailSettings,
    accessToken: QPilotAccessToken,
  ): Observable<ISiteEmailSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ThemingSettings/EmailStyles`;
    return this.httpPut<
      {
        LogoUrl?: string;
        EmailTemplatesStyleSettings?: IEmailTemplateStyleSettings;
      },
      ISiteEmailSettings
    >(
      endpoint,
      {
        LogoUrl: siteEmailSettings.logoUrl,
        EmailTemplatesStyleSettings:
          siteEmailSettings.emailTemplatesStyleSettings,
      },
      accessToken,
    );
  }

  /**
   * Adds a new scheduled order days notification
   * @param siteId Site ID
   * @param notification Notification to add
   * @param accessToken Access token
   * @returns Observable with the created notification
   */
  public addScheduledOrderDaysNotification(
    siteId: number,
    notification: Omit<IScheduledOrderDaysNotification, "id">,
    accessToken: QPilotAccessToken,
  ): Observable<IScheduledOrderDaysNotification> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrderDaysNotifications`;
    return this.httpPost<
      Omit<IScheduledOrderDaysNotification, "id">,
      IScheduledOrderDaysNotification
    >(endpoint, notification, accessToken);
  }

  /**
   * Updates a scheduled order days notification
   * @param siteId Site ID
   * @param notificationId Notification ID
   * @param notification Notification updates
   * @param accessToken Access token
   * @returns Observable with the updated notification
   */
  public updateScheduledOrderDaysNotification(
    siteId: number,
    notificationId: number,
    notification: Partial<IScheduledOrderDaysNotification>,
    accessToken: QPilotAccessToken,
  ): Observable<IScheduledOrderDaysNotification> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrderDaysNotifications/${notificationId}`;
    return this.httpPut<
      Partial<IScheduledOrderDaysNotification>,
      IScheduledOrderDaysNotification
    >(endpoint, notification, accessToken);
  }

  /**
   * Deletes a scheduled order days notification
   * @param siteId Site ID
   * @param notificationId Notification ID
   * @param accessToken Access token
   * @returns Observable that completes when deletion is successful
   */
  public deleteScheduledOrderDaysNotification(
    siteId: number,
    notificationId: number,
    accessToken: QPilotAccessToken,
  ): Observable<void> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrderDaysNotifications/${notificationId}`;
    return this.httpDelete<void>(endpoint, accessToken);
  }

  /**
   * Gets email template by template ID
   * @param templateId Template ID
   * @param accessToken Access token
   * @returns Observable with the email template
   */
  public getEmailTemplate(
    templateId: string,
    accessToken: QPilotAccessToken,
  ): Observable<IEmailTemplateSetting> {
    const endpoint = `${this.qpilotUrl}/EmailTemplates/${templateId}`;
    return this.httpGet<IEmailTemplateSetting>(endpoint, accessToken);
  }

  /**
   * Updates email template
   * @param templateId Template ID
   * @param template Template settings
   * @param accessToken Access token
   * @returns Observable with the updated template
   */
  public updateEmailTemplate(
    templateId: string,
    template: IEmailTemplateSetting,
    accessToken: QPilotAccessToken,
  ): Observable<IEmailTemplateSetting> {
    const endpoint = `${this.qpilotUrl}/EmailTemplates/${templateId}`;
    return this.httpPut<IEmailTemplateSetting, IEmailTemplateSetting>(
      endpoint,
      template,
      accessToken,
    );
  }

  // ========== Email Template Editor Methods ==========

  /**
   * Gets email template by site ID and template type for editing
   * @param siteId Site ID
   * @param templateType Template type
   * @param accessToken Access token
   * @returns Observable with the email template
   */
  public getEmailTemplateForEdit(
    siteId: number,
    templateType: EmailTemplateType,
    accessToken: QPilotAccessToken,
  ): Observable<IEmailTemplate> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailTemplates/${templateType}`;
    return this.httpGet<IEmailTemplate>(endpoint, accessToken);
  }

  /**
   * Updates email template by site ID and template type
   * @param siteId Site ID
   * @param templateType Template type
   * @param template Template data
   * @param accessToken Access token
   * @returns Observable with updated template
   */
  public updateEmailTemplateForEdit(
    siteId: number,
    templateType: EmailTemplateType,
    template: IEmailTemplate,
    accessToken: QPilotAccessToken,
  ): Observable<IEmailTemplate> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailTemplates/${templateType}`;
    return this.httpPut<IEmailTemplate, IEmailTemplate>(
      endpoint,
      template,
      accessToken,
    );
  }

  /**
   * Resets email template to default values
   * @param siteId Site ID
   * @param templateType Template type
   * @param accessToken Access token
   * @returns Observable with reset template
   */
  public resetEmailTemplateToDefault(
    siteId: number,
    templateType: EmailTemplateType,
    accessToken: QPilotAccessToken,
  ): Observable<IEmailTemplate> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailTemplates/${templateType}/reset`;
    return this.httpPost<object, IEmailTemplate>(endpoint, {}, accessToken);
  }

  /**
   * Updates email template number of days settings
   * @param siteId Site ID
   * @param siteEmailSettings Email settings
   * @param accessToken Access token
   * @returns Observable with updated settings
   */
  public updateEmailTemplateNumberOfDaysSettings(
    siteId: number,
    siteEmailSettings: SiteEmailSettings,
    accessToken: QPilotAccessToken,
  ): Observable<SiteEmailSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailTemplateSettings/NumberOfDays`;
    return this.httpPut<unknown, SiteEmailSettings>(
      endpoint,
      {
        NumberOfDaysEmailTemplateSettings:
          siteEmailSettings.NumberOfDaysEmailTemplateSettings,
      },
      accessToken,
    );
  }

  /**
   * Updates email template lock notification settings
   * @param siteId Site ID
   * @param siteEmailSettings Email settings
   * @param accessToken Access token
   * @returns Observable with updated settings
   */
  public updateEmailTemplateLockNotificationSettings(
    siteId: number,
    siteEmailSettings: SiteEmailSettings,
    accessToken: QPilotAccessToken,
  ): Observable<SiteEmailSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailTemplateSettings/LockNotification`;
    return this.httpPut<unknown, SiteEmailSettings>(
      endpoint,
      {
        LockNotificationsEmailTemplateSettings:
          siteEmailSettings.LockNotificationsEmailTemplateSettings,
      },
      accessToken,
    );
  }

  /**
   * Updates scheduled order error customer template settings
   * @param siteId Site ID
   * @param scheduledOrderErrorCustomerTemplateSettings Array of error template settings (matching old QMC)
   * @param accessToken Access token
   * @returns Observable with updated settings
   */
  public updateScheduledOrderErrorCustomerTemplateSettings(
    siteId: number,
    scheduledOrderErrorCustomerTemplateSettings: unknown[],
    accessToken: QPilotAccessToken,
  ): Observable<unknown> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailTemplateSettings/ScheduledOrderError`;
    return this.httpPut<unknown, unknown>(
      endpoint,
      {
        ScheduledOrderErrorEmailSettings:
          scheduledOrderErrorCustomerTemplateSettings,
      },
      accessToken,
    );
  }

  /**
   * Updates email template scheduled order created notification settings
   * @param siteId Site ID
   * @param siteEmailSettings Email settings
   * @param accessToken Access token
   * @returns Observable with updated settings
   */
  public updateEmailTemplateScheduledOrderCreatedNotificationSettings(
    siteId: number,
    siteEmailSettings: SiteEmailSettings,
    accessToken: QPilotAccessToken,
  ): Observable<SiteEmailSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailTemplateSettings/ScheduledOrderCreated`;
    return this.httpPut<unknown, SiteEmailSettings>(
      endpoint,
      {
        EmailTemplateSettings:
          siteEmailSettings.ScheduledOrderCreatedEmailTemplateSettings,
      },
      accessToken,
    );
  }

  /**
   * Updates email template scheduled order deleted notification settings
   * @param siteId Site ID
   * @param siteEmailSettings Email settings
   * @param accessToken Access token
   * @returns Observable with updated settings
   */
  public updateEmailTemplateScheduledOrderDeletedNotificationSettings(
    siteId: number,
    siteEmailSettings: SiteEmailSettings,
    accessToken: QPilotAccessToken,
  ): Observable<SiteEmailSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailTemplateSettings/ScheduledOrderDeleted`;
    return this.httpPut<unknown, SiteEmailSettings>(
      endpoint,
      {
        EmailTemplateSettings:
          siteEmailSettings.ScheduledOrderDeletedEmailTemplateSettings,
      },
      accessToken,
    );
  }

  /**
   * Updates email template scheduled order paused notification settings
   * @param siteId Site ID
   * @param siteEmailSettings Email settings
   * @param accessToken Access token
   * @returns Observable with updated settings
   */
  public updateEmailTemplateScheduledOrderPausedNotificationSettings(
    siteId: number,
    siteEmailSettings: SiteEmailSettings,
    accessToken: QPilotAccessToken,
  ): Observable<SiteEmailSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailTemplateSettings/ScheduledOrderPaused`;
    return this.httpPut<unknown, SiteEmailSettings>(
      endpoint,
      {
        EmailTemplateSettings:
          siteEmailSettings.ScheduledOrderPausedEmailTemplateSettings,
      },
      accessToken,
    );
  }

  /**
   * Updates email template scheduled order payment auth notification settings
   * @param siteId Site ID
   * @param siteEmailSettings Email settings
   * @param accessToken Access token
   * @returns Observable with updated settings
   */
  public updateEmailTemplateScheduledOrderPaymentAuthNotificationSettings(
    siteId: number,
    siteEmailSettings: SiteEmailSettings,
    accessToken: QPilotAccessToken,
  ): Observable<SiteEmailSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailTemplateSettings/ScheduledOrderPaymentAuth`;
    return this.httpPut<unknown, SiteEmailSettings>(
      endpoint,
      {
        EmailTemplateSettings:
          siteEmailSettings.ScheduledOrderPaymentAuthEmailTemplateSettings,
      },
      accessToken,
    );
  }

  /**
   * Generates email template preview with sample data
   * @param siteId Site ID
   * @param templateType Template type
   * @param template Template data
   * @param previewData Preview data (optional)
   * @param accessToken Access token
   * @returns Observable with HTML preview
   */
  public previewEmailTemplate(
    siteId: number,
    templateType: EmailTemplateType,
    template: IEmailTemplate,
    previewData: ITemplatePreviewData,
    accessToken: QPilotAccessToken,
  ): Observable<string> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailTemplates/${templateType}/preview`;
    const payload = {
      template,
      previewData,
    };
    return this.httpPost<typeof payload, string>(
      endpoint,
      payload,
      accessToken,
    );
  }

  /**
   * Gets available template variables for a template type
   * @param templateType Template type
   * @param accessToken Access token
   * @returns Observable with template variables
   */
  public getTemplateVariables(
    templateType: EmailTemplateType,
    accessToken: QPilotAccessToken,
  ): Observable<ITemplateVariable[]> {
    const endpoint = `${this.qpilotUrl}/EmailTemplates/${templateType}/variables`;
    return this.httpGet<ITemplateVariable[]>(endpoint, accessToken);
  }

  /**
   * Validates email template content
   * @param siteId Site ID
   * @param templateType Template type
   * @param template Template to validate
   * @param accessToken Access token
   * @returns Observable with validation results
   */
  public validateEmailTemplate(
    siteId: number,
    templateType: EmailTemplateType,
    template: IEmailTemplate,
    accessToken: QPilotAccessToken,
  ): Observable<IValidationResult> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/EmailTemplates/${templateType}/validate`;
    return this.httpPost<IEmailTemplate, IValidationResult>(
      endpoint,
      template,
      accessToken,
    );
  }

  /**
   * Gets template metadata including available fields and requirements
   * @param templateType Template type
   * @param accessToken Access token
   * @returns Observable with template metadata
   */
  public getEmailTemplateMetadata(
    templateType: EmailTemplateType,
    accessToken: QPilotAccessToken,
  ): Observable<unknown> {
    const endpoint = `${this.qpilotUrl}/EmailTemplates/${templateType}/metadata`;
    return this.httpGet<unknown>(endpoint, accessToken);
  }

  /**
   * Gets latest scheduled orders for email preview - ported from old QMC
   * @param siteId Site ID
   * @param accessToken Access token
   * @param notificationType MessageType enum value
   * @param getFailedOrders Whether to get failed orders (for error templates)
   * @returns Observable with email preview data
   */
  public getLatestScheduledOrders(
    siteId: number,
    accessToken: QPilotAccessToken,
    notificationType: MessageType,
    getFailedOrders: boolean = false,
  ): Observable<EmailPreviewDto> {
    const endpoint = `${this.newQpilotUrl}/Sites/${siteId}/EmailPreview/LatestScheduledOrders`;

    // Build query parameters - matching old QMC exactly
    const params = new URLSearchParams();
    params.append("messageType", notificationType.toString());
    if (getFailedOrders) {
      params.append("getFailedOrders", "true");
    }

    const urlWithParams = `${endpoint}?${params.toString()}`;
    return this.httpGet<EmailPreviewDto>(urlWithParams, accessToken);
  }

  /**
   * Sends test email for email preview - ported from old QMC
   * @param siteId Site ID
   * @param request Email preview request with recipients and settings
   * @param accessToken Access token
   * @returns Observable for the send operation
   */
  public sendTestEmail(
    siteId: number,
    request: EmailPreviewRequest,
    accessToken: QPilotAccessToken,
  ): Observable<unknown> {
    const endpoint = `${this.newQpilotUrl}/Sites/${siteId}/EmailPreview/SendTestEmail`;
    return this.httpPost<EmailPreviewRequest, unknown>(
      endpoint,
      request,
      accessToken,
    );
  }

  /**
   * Parses error message from API response - utility method from old QMC
   * @param error The error object
   * @returns User-friendly error message
   */
  public parseErrorMessage(error: unknown): string {
    if (typeof error === "string") {
      return error;
    }

    if (error && typeof error === "object") {
      const errorObj = error as {
        error?: { message?: string; Message?: string };
        message?: string;
        Message?: string;
      };

      // Try different possible error message paths
      if (errorObj.error?.message) {
        return errorObj.error.message;
      }
      if (errorObj.error?.Message) {
        return errorObj.error.Message;
      }
      if (errorObj.message) {
        return errorObj.message;
      }
      if (errorObj.Message) {
        return errorObj.Message;
      }
    }

    return "An unexpected error occurred. Please try again.";
  }

  // ========== Scheduled Orders Methods ==========

  /**
   * Get scheduled orders with filtering and pagination
   */
  getScheduledOrders(
    filter: ScheduledOrdersFilter,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<PagedResult<ScheduledOrderListItem>> {
    const endpoint = `${this.qpilotUrl}/Sites/${filter.siteId}/ScheduledOrders?${this.buildScheduledOrdersQueryParams(filter)}`;

    return this.httpGet<any>(endpoint, accessToken, showGlobalLoader).pipe(
      map((response) => ({
        Items: this.transformToScheduledOrderListItems(response.Items || []),
        TotalRecords: response.TotalRecords || 0,
        Page: response.Page || filter.page,
        PageSize: response.PageSize || filter.pageSize,
      })),
    );
  }

  /**
   * Get a single scheduled order by ID (for display in lists/tables)
   * Returns transformed ScheduledOrderListItem with limited fields
   */
  getScheduledOrder(
    scheduledOrderId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ScheduledOrderListItem> {
    const endpoint = `${this.qpilotUrl}/ScheduledOrders/${scheduledOrderId}`;

    return this.httpGet<any>(endpoint, accessToken, showGlobalLoader).pipe(
      map((response) => this.transformToScheduledOrderListItem(response)),
    );
  }

  /**
   * Get a single scheduled order by ID with full data (for editing)
   * Returns raw response as ScheduledOrder with Customer and ScheduledOrderItems
   */
  getScheduledOrderFull(
    scheduledOrderId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<any> {
    const endpoint = `${this.qpilotUrl}/ScheduledOrders/${scheduledOrderId}`;

    // Return raw response without transformation to preserve all fields
    return this.httpGet<any>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get scheduled orders count by status
   */
  getScheduledOrderCounts(
    filter: ScheduledOrdersFilter,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ScheduledOrderCounts> {
    const endpoint = `${this.qpilotUrl}/Sites/${filter.siteId}/ScheduledOrders/Count?${this.buildScheduledOrdersQueryParams(filter)}`;

    return this.httpGet<ScheduledOrderCounts>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Delete a scheduled order
   */
  deleteScheduledOrder(
    siteId: number,
    orderId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<void> {
    const endpoint = `${this.qpilotUrl}/ScheduledOrders/${orderId}`;

    return this.httpDelete<void>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Create a new scheduled order
   * Priority 1 - Core CRUD Operation
   */
  createScheduledOrder(
    scheduledOrder: ScheduledOrder,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ScheduledOrder> {
    const endpoint = `${this.qpilotUrl}/ScheduledOrders`;

    return this.httpPost<ScheduledOrder, ScheduledOrder>(
      endpoint,
      scheduledOrder,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Update an existing scheduled order
   * Priority 1 - Core CRUD Operation
   */
  updateScheduledOrder(
    scheduledOrder: ScheduledOrder,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ScheduledOrder> {
    const endpoint = `${this.qpilotUrl}/ScheduledOrders/${scheduledOrder.Id}`;

    return this.httpPut<ScheduledOrder, ScheduledOrder>(
      endpoint,
      scheduledOrder,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Retry a scheduled order (restart processing)
   */
  retryScheduledOrder(
    siteId: number,
    orderId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<any> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/${orderId}/Retry`;

    return this.httpPost<any, any>(endpoint, {}, accessToken, showGlobalLoader);
  }

  /**
   * Activate a scheduled order
   */
  activateScheduledOrder(
    siteId: number,
    orderId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<any> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/${orderId}/Activate`;

    // Use PUT method to match old QMC
    return this.httpPut<any, any>(
      endpoint,
      null,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Pause a scheduled order
   * Priority 1 - Order Management Operations
   */
  pauseScheduledOrder(
    siteId: number,
    orderId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<any> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/${orderId}/Pause`;

    // Use PUT method to match old QMC
    return this.httpPut<any, any>(
      endpoint,
      null,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Resume a paused scheduled order
   * Priority 1 - Order Management Operations
   */
  resumeScheduledOrder(
    siteId: number,
    orderId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<any> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/${orderId}/Resume`;

    // Use PUT method to match old QMC
    return this.httpPut<any, any>(
      endpoint,
      null,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Process scheduled order now (queue for immediate processing)
   * Priority 1 - Order Management Operations
   */
  processScheduledOrderNow(
    siteId: number,
    orderId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<any> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/${orderId}/ProcessNow`;

    // Use POST method to match old QMC
    return this.httpPost<any, any>(endpoint, {}, accessToken, showGlobalLoader);
  }

  /**
   * Clone/duplicate a scheduled order
   * Priority 1 - Order Management Operations
   */
  cloneScheduledOrder(
    siteId: number,
    orderId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ScheduledOrder> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/${orderId}/Clone`;

    // Use POST method to match old QMC, returns the new cloned order
    return this.httpPost<any, ScheduledOrder>(
      endpoint,
      {},
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Retry update order (for error code 3001)
   */
  retryUpdateOrder(
    siteId: number,
    orderId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<any> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/${orderId}/RetryUpdate`;

    return this.httpPost<any, any>(endpoint, {}, accessToken, showGlobalLoader);
  }

  /**
   * Bulk process scheduled orders
   */
  bulkProcessingOrders(
    siteId: number,
    orderIds: number[],
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<BulkSOActionsResponse[]> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/BulkProcessing`;

    return this.httpPost<number[], BulkSOActionsResponse[]>(
      endpoint,
      orderIds,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Bulk update status of scheduled orders (matches old QMC API)
   */
  bulkUpdateStatus(
    siteId: number,
    orderIds: number[],
    status: string,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<BulkSOActionsResponse[]> {
    // Use the old QMC endpoint format: BulkStatusChange/{status}
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/BulkStatusChange/${status}`;

    // Use PUT method like old QMC with array of IDs as body
    return this.httpPut<number[], BulkSOActionsResponse[]>(
      endpoint,
      orderIds,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Export scheduled orders to CSV
   */
  exportScheduledOrders(
    filter: ScheduledOrdersFilter,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<string> {
    const endpoint = `${this.qpilotUrl}/Sites/${filter.siteId}/ScheduledOrders/Export?${this.buildScheduledOrdersQueryParams(filter)}`;

    return this.httpGet<string>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Validate scheduled order for processing (pre-processing checks)
   * Uses POST with full order object to match API requirements
   * @param siteId - The site ID
   * @param scheduledOrder - The full scheduled order object to validate
   * @param accessToken - Access token
   * @param showGlobalLoader - Whether to show global loader
   * @returns Observable of ValidationResult
   */
  validateScheduledOrder(
    siteId: number,
    scheduledOrder: any, // Full order object required by API
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ValidationResult> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/GetPreValidationResult`;

    return this.httpPost<any, ValidationResult>(
      endpoint,
      scheduledOrder,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Get pre-validation result for a scheduled order (used by validation dialog)
   * This method runs fresh validation checks WITHOUT persisting to database
   * OLD QMC: qpilot.service.ts lines 2031-2046
   * @param siteId - The site ID
   * @param scheduledOrder - The full scheduled order object to validate
   * @param accessToken - Access token
   * @param showGlobalLoader - Whether to show global loader
   * @returns Observable of ValidationResult
   */
  getScheduledOrderPreValidationResult(
    siteId: number,
    scheduledOrder: any, // Full scheduled order object (same as old QMC)
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ValidationResult> {
    // OLD QMC endpoint: /Sites/{siteId}/ScheduledOrders/GetPreValidationResult (POST with order body)
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/GetPreValidationResult`;

    // POST the full order object for validation (matches old QMC)
    return this.httpPost<any, ValidationResult>(
      endpoint,
      scheduledOrder,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Update scheduled order pre-validation result (persists to database)
   * @param siteId - The site ID
   * @param orderId - The scheduled order ID
   * @param accessToken - Access token
   * @param showGlobalLoader - Whether to show global loader
   * @returns Observable of ValidationResult
   */
  updateScheduledOrderPreValidationResult(
    siteId: number,
    orderId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ValidationResult> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/${orderId}/UpdatePreValidationResult`;

    return this.httpPut<null, ValidationResult>(
      endpoint,
      null,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Calculate scheduled order totals preview
   * Priority 2 - Calculation & Validation
   */
  scheduledOrderRecalculatePreview(
    siteId: number,
    scheduledOrder: ScheduledOrder,
    accessToken: QPilotAccessToken,
  ): Observable<ScheduledOrderTotals> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/CalculateTotals`;

    return this.httpPost<ScheduledOrder, ScheduledOrderTotals>(
      endpoint,
      scheduledOrder,
      accessToken,
    );
  }

  /**
   * Validate scheduled order coupons
   * Priority 2 - Calculation & Validation
   */
  validateScheduledOrderCoupons(
    siteId: number,
    scheduledOrder: ScheduledOrder,
    accessToken: QPilotAccessToken,
  ): Observable<ScheduledOrderCoupon[]> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/ValidateCoupons`;

    return this.httpPost<ScheduledOrder, ScheduledOrderCoupon[]>(
      endpoint,
      scheduledOrder,
      accessToken,
    );
  }

  // ========== Priority 3 - Resource Endpoints for Create/Edit ==========

  /**
   * Get site settings
   * Priority 3 - Supporting Resources
   */
  getSiteSettings(
    siteId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<SiteSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/Settings`;

    return this.httpGet<SiteSettings>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get dunning settings for a site
   * Priority 3 - Supporting Resources
   */
  getDunningSettings(
    siteId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<DunningSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/Settings/Dunning`;

    return this.httpGet<DunningSettings>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Update (upsert) dunning settings for a site
   * Priority 3 - Supporting Resources
   */
  updateDunningSettings(
    siteId: number,
    settings: DunningSettings,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<DunningSettings> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/Settings/Dunning`;

    return this.httpPost<DunningSettings, DunningSettings>(
      endpoint,
      settings,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Get payment methods for a customer
   * Priority 3 - Supporting Resources
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getPaymentMethodsForCustomer(
    customerId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<QPilotPaymentMethod[]> {
    const endpoint = `${this.qpilotUrl}/Customers/${customerId}/PaymentMethods`;

    return this.httpGet<QPilotPaymentMethod[]>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Get payment integrations for a site
   * Priority 3 - Supporting Resources
   */
  getPaymentIntegrationsForSite(
    siteId: number,
    accessToken: QPilotAccessToken,
    page: number = 1,
    showGlobalLoader: boolean = false,
  ): Observable<PaymentIntegrationsResponse> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/PaymentIntegrations?page=${page}`;

    return this.httpGet<PaymentIntegrationsResponse>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Get shipping addresses for a site
   * Priority 3 - Supporting Resources
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getShippingAddressesForSite(
    siteId: number,
    accessToken: QPilotAccessToken,
    page: number = 1,
    showGlobalLoader: boolean = false,
  ): Observable<any> {
    // TODO: Replace any with QPilotPagedResult<QPilotShippingAddress> when available
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ShippingAddresses?page=${page}`;

    return this.httpGet<any>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get coupons for a site (with optional search)
   * Priority 3 - Supporting Resources
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCouponsForSite(
    siteId: number,
    accessToken: QPilotAccessToken,
    page: number = 1,
    search?: string,
    showGlobalLoader: boolean = false,
  ): Observable<any> {
    // TODO: Replace any with QPilotPagedResult<QPilotCoupon> when available
    let endpoint = `${this.qpilotUrl}/Sites/${siteId}/Coupons?page=${page}`;

    if (search && search.trim()) {
      endpoint += `&search=${encodeURIComponent(search.trim())}`;
    }

    return this.httpGet<any>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get customers for a site (with optional search)
   * Priority 3 - Supporting Resources
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCustomersForSite(
    siteId: number,
    accessToken: QPilotAccessToken,
    page: number = 1,
    search?: string,
    showGlobalLoader: boolean = false,
  ): Observable<any[]> {
    // TODO: Replace any with QPilotCustomer interface when available
    let endpoint = `${this.qpilotUrl}/Sites/${siteId}/Customers?page=${page}`;

    if (search && search.trim()) {
      endpoint += `&search=${encodeURIComponent(search.trim())}`;
    }

    return this.httpGet<any[]>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get products for a site (with optional search)
   * Priority 3 - Supporting Resources
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getProductsForSite(
    siteId: number,
    accessToken: QPilotAccessToken,
    page: number = 1,
    search?: string,
    showGlobalLoader: boolean = false,
  ): Observable<any[]> {
    // TODO: Replace any with QPilotProduct interface when available
    let endpoint = `${this.qpilotUrl}/Sites/${siteId}/Products?page=${page}`;

    if (search && search.trim()) {
      endpoint += `&search=${encodeURIComponent(search.trim())}`;
    }

    return this.httpGet<any[]>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get a single product by external ID
   * Matches old QMC: /Sites/{siteId}/Products/{externalId}
   * Returns the full product details including ImageUrl
   */
  getProductByExternalId(
    siteId: number,
    externalId: string,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<QPilotProduct> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/Products/${externalId}`;
    return this.httpGet<QPilotProduct>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get product summaries for a site with filtering support
   * This is the main endpoint for the Products list page
   * Matches old QMC: /Sites/{siteId}/Products/Summaries?{queryParams}
   * Old QMC format: page=1&pageSize=20&orderBy=ProductName&order=asc&status=Active&offset=3&active=true&valid=true
   */
  getProductSummariesForSite(
    siteId: number,
    accessToken: QPilotAccessToken,
    filters: {
      page?: number;
      pageSize?: number;
      orderBy?: string;
      order?: "asc" | "desc";
      status?: string;
      search?: string;
      active?: boolean;
      valid?: boolean;
      productGroupId?: number;
      offset?: number;
    } = {},
    showGlobalLoader: boolean = false,
  ): Observable<ProductSummary[]> {
    let endpoint = `${this.qpilotUrl}/Sites/${siteId}/Products/Summaries?`;

    // Build query parameters matching old QMC format exactly
    const params: string[] = [];
    if (filters.page !== undefined) params.push(`page=${filters.page}`);
    if (filters.pageSize !== undefined)
      params.push(`pageSize=${filters.pageSize}`);
    if (filters.orderBy) params.push(`orderBy=${filters.orderBy}`);
    if (filters.order) params.push(`order=${filters.order}`);
    if (filters.status) params.push(`status=${filters.status}`);
    if (filters.offset !== undefined) params.push(`offset=${filters.offset}`);
    if (filters.search)
      params.push(`search=${encodeURIComponent(filters.search)}`);
    if (filters.active !== undefined) params.push(`active=${filters.active}`);
    if (filters.valid !== undefined) params.push(`valid=${filters.valid}`);
    if (filters.productGroupId !== undefined)
      params.push(`productGroupId=${filters.productGroupId}`);

    endpoint += params.join("&");

    return this.httpGet<ProductSummary[]>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Get product summaries count for a site
   * Matches old QMC: /Sites/{siteId}/Products/Summaries/Count?{queryParams}
   * Old QMC format: page=1&pageSize=20&orderBy=ProductName&order=asc&status=Active&offset=3&active=true&valid=true
   */
  getProductSummariesCount(
    siteId: number,
    accessToken: QPilotAccessToken,
    filters: {
      page?: number;
      pageSize?: number;
      orderBy?: string;
      order?: "asc" | "desc";
      status?: string;
      search?: string;
      active?: boolean;
      valid?: boolean;
      productGroupId?: number;
      offset?: number;
    } = {},
    showGlobalLoader: boolean = false,
  ): Observable<ProductSummariesCount> {
    let endpoint = `${this.qpilotUrl}/Sites/${siteId}/Products/Summaries/Count?`;

    // Build query parameters matching old QMC format exactly
    const params: string[] = [];
    if (filters.page !== undefined) params.push(`page=${filters.page}`);
    if (filters.pageSize !== undefined)
      params.push(`pageSize=${filters.pageSize}`);
    if (filters.orderBy) params.push(`orderBy=${filters.orderBy}`);
    if (filters.order) params.push(`order=${filters.order}`);
    if (filters.status) params.push(`status=${filters.status}`);
    if (filters.offset !== undefined) params.push(`offset=${filters.offset}`);
    if (filters.search)
      params.push(`search=${encodeURIComponent(filters.search)}`);
    if (filters.active !== undefined) params.push(`active=${filters.active}`);
    if (filters.valid !== undefined) params.push(`valid=${filters.valid}`);
    if (filters.productGroupId !== undefined)
      params.push(`productGroupId=${filters.productGroupId}`);

    endpoint += params.join("&");

    return this.httpGet<ProductSummariesCount>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Get product groups for a site
   * Matches old QMC: /Sites/{siteId}/ProductGroups
   */
  getProductGroups(
    siteId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ProductGroup[]> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ProductGroups`;
    return this.httpGet<ProductGroup[]>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Get a single product group by ID
   * Matches old QMC: /Sites/{siteId}/ProductGroups/{id}
   */
  getProductGroup(
    siteId: number,
    id: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ProductGroup> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ProductGroups/${id}`;
    return this.httpGet<ProductGroup>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Create a new product group
   * Matches old QMC: POST /Sites/{siteId}/ProductGroups
   */
  createProductGroup(
    siteId: number,
    productGroup: Partial<ProductGroup>,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ProductGroup> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ProductGroups`;
    return this.httpPost<Partial<ProductGroup>, ProductGroup>(
      endpoint,
      productGroup,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Update an existing product group
   * Matches old QMC: PUT /Sites/{siteId}/ProductGroups/{id}
   */
  updateProductGroup(
    siteId: number,
    productGroup: ProductGroup,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ProductGroup> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ProductGroups/${productGroup.ProductGroupId}`;
    return this.httpPut<ProductGroup, ProductGroup>(
      endpoint,
      productGroup,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Delete a product group
   * Matches old QMC: DELETE /Sites/{siteId}/ProductGroups/{id}
   */
  deleteProductGroup(
    siteId: number,
    productGroupId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<void> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ProductGroups/${productGroupId}`;
    return this.httpDelete(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Update a product summary (availability, active status, etc.)
   * Uses PUT to /Sites/{siteId}/products/Summaries/{ExternalId}/
   * This is the correct endpoint for updating product availability checkboxes
   */
  updateProductSummary(
    siteId: number,
    productSummary: ProductSummary,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ProductSummaryUpdateResponse> {
    // Note: The endpoint uses the ExternalId, not the Id
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/products/Summaries/${productSummary.ExternalId}/`;

    return this.httpPut<ProductSummary, ProductSummaryUpdateResponse>(
      endpoint,
      productSummary,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Batch update products (sync prices, sale prices, etc.)
   * PUT /api/Products/BatchUpdate
   * Payload: {"BatchAction":"UpdatePrice|UpdateSalePrice|Delete","SiteId":number,"ProductIds":"[\"id1\",\"id2\"]"}
   * Note: ProductIds should be ExternalId values (strings)
   */
  batchUpdateProducts(
    siteId: number,
    productIds: string[],
    batchAction: "UpdatePrice" | "UpdateSalePrice" | "Delete",
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ProductBatchUpdateResponse> {
    const endpoint = `${this.qpilotUrl}/Products/BatchUpdate`;

    // ProductIds must be a JSON string array of ExternalIds
    const payload = {
      BatchAction: batchAction,
      SiteId: siteId,
      ProductIds: JSON.stringify(productIds),
    };

    return this.httpPut<typeof payload, ProductBatchUpdateResponse>(
      endpoint,
      payload,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Batch update ALL products for a site (sync all prices, all sale prices)
   * PUT /api/Products/BatchUpdateAll
   * Payload: {"BatchAction":"UpdatePrice|UpdateSalePrice","SiteId":number}
   */
  batchUpdateAllProducts(
    siteId: number,
    batchAction: "UpdatePrice" | "UpdateSalePrice",
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<ProductBatchUpdateResponse> {
    const endpoint = `${this.qpilotUrl}/Products/BatchUpdateAll`;

    const payload = {
      BatchAction: batchAction,
      SiteId: siteId,
    };

    return this.httpPut<typeof payload, ProductBatchUpdateResponse>(
      endpoint,
      payload,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Delete a single product
   * DELETE /api/Products/{productId}
   * Matches old QMC single product deletion
   */
  deleteProduct(
    productId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<void> {
    const endpoint = `${this.qpilotUrl}/Products/${productId}`;
    return this.httpDelete<void>(endpoint, accessToken, showGlobalLoader);
  }

  // ========== Priority 4 - Shipping & Advanced Features ==========

  /**
   * Get shipping rate options for a scheduled order
   * Priority 4 - Shipping & Advanced Features
   */
  getScheduledOrderShippingRateOptions(
    siteId: number,
    scheduledOrder: ScheduledOrder,
    accessToken: QPilotAccessToken,
  ): Observable<ScheduledOrderShippingRateOption[]> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/GetScheduledOrderShippingRateOptions`;

    return this.httpPost<ScheduledOrder, ScheduledOrderShippingRateOption[]>(
      endpoint,
      scheduledOrder,
      accessToken,
    );
  }

  /**
   * Check if Nextime integration exists for a site
   * Priority 4 - Shipping & Advanced Features
   */
  getNextimeSiteIdIfExists(
    siteId: number,
    accessToken: QPilotAccessToken,
  ): Observable<NextimeSiteIdResponse> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ShippingRates/Nextime`;

    return this.httpGet<NextimeSiteIdResponse>(endpoint, accessToken);
  }

  /**
   * Get other payment methods from external gateway (Stripe, Braintree, etc.)
   * Priority 4 - Shipping & Advanced Features
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getOtherPaymentMethods(
    siteId: number,
    gatewayCustomerId: string,
    gatewayType: string,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<QPilotPaymentMethod[]> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/OtherPaymentMethods/${gatewayCustomerId}/${gatewayType}`;

    return this.httpGet<QPilotPaymentMethod[]>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Create a new payment method
   * Priority 4 - Shipping & Advanced Features
   */
  createPaymentMethod(
    paymentMethod: QPilotPaymentMethod,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<QPilotPaymentMethod> {
    const endpoint = `${this.qpilotUrl}/PaymentMethods`;

    return this.httpPost<QPilotPaymentMethod, QPilotPaymentMethod>(
      endpoint,
      paymentMethod,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Get page permissions by URL for subscription tier validation
   * Priority 4 - Shipping & Advanced Features
   */
  getPageByUrl(
    pageUrl: string,
    siteId: string,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<SubPage> {
    const endpoint = `${this.newQpilotUrl}/UsersPermissions/Page/${pageUrl}/${siteId}`;

    return this.httpGet<SubPage>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get site subscription tier information
   * Priority 4 - Shipping & Advanced Features
   */
  fetchSiteSubscriptionTier(
    accessToken: QPilotAccessToken,
    siteId: string,
    showGlobalLoader: boolean = false,
  ): Observable<SiteTier> {
    const endpoint = `${this.qpilotUrl}/SitesConfigurations/${siteId}/tier`;

    return this.httpGet<SiteTier>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get scheduled order event logs (used by history dialog)
   */
  getScheduledOrderEventLogs(
    scheduledOrderId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<any[]> {
    const endpoint = `${this.qpilotUrl}/ScheduledOrders/${scheduledOrderId}/EventLogs`;

    return this.httpGet<any[]>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get scheduled order processing cycles (used by cycles dialog)
   */
  getScheduledOrderProcessingCycles(
    accessToken: QPilotAccessToken,
    scheduledOrderId: number,
    siteId: number,
    showGlobalLoader: boolean = false,
  ): Observable<ProcessingCycleListResponse> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/${scheduledOrderId}/ProcessingCycles`;

    return this.httpGet<ProcessingCycleListResponse>(
      endpoint,
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Get processing cycle logs (used by processing cycle logs dialog)
   * Matches old QMC getProcessingLogs method exactly
   */
  getProcessingLogs(
    accessToken: QPilotAccessToken,
    siteId: number,
    processingCycleId: number,
    showGlobalLoader: boolean = false,
  ): Observable<any> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ProcessingCycles/${processingCycleId}/ProcessingLogs`;

    return this.httpGet<any>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get a single processing cycle by ID
   * Matches old QMC getProcessingCycle method
   */
  getProcessingCycle(
    accessToken: QPilotAccessToken,
    siteId: number,
    processingCycleId: number,
    showGlobalLoader: boolean = false,
  ): Observable<
    import("../../features/scheduled-orders/interfaces/processing-cycle.interface").ProcessingCycle
  > {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ProcessingCycles/${processingCycleId}`;

    return this.httpGet<
      import("../../features/scheduled-orders/interfaces/processing-cycle.interface").ProcessingCycle
    >(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Complete a processing cycle manually
   * Matches old QMC completeLastProcessingCycle method
   */
  completeProcessingCycle(
    siteId: number,
    scheduledOrderId: number,
    request: import("../../features/scheduled-orders/interfaces/processing-cycle.interface").ProcessingCycleCompleteRequest,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<void> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/${scheduledOrderId}/CompleteLastProcessingCycle`;

    return this.httpPost<
      import("../../features/scheduled-orders/interfaces/processing-cycle.interface").ProcessingCycleCompleteRequest,
      void
    >(endpoint, request, accessToken, showGlobalLoader);
  }

  /**
   * Void a processing cycle
   * Matches old QMC voidLastProcessingCycle method
   */
  voidProcessingCycle(
    siteId: number,
    scheduledOrderId: number,
    request: import("../../features/scheduled-orders/interfaces/processing-cycle.interface").ProcessingCycleVoidRequest,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<void> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/${scheduledOrderId}/VoidLastProcessingCycle`;

    return this.httpPost<
      import("../../features/scheduled-orders/interfaces/processing-cycle.interface").ProcessingCycleVoidRequest,
      void
    >(endpoint, request, accessToken, showGlobalLoader);
  }

  /**
   * Edit a processing cycle
   * Matches old QMC editProcessingCycle method
   */
  editProcessingCycle(
    siteId: number,
    processingCycleId: number,
    request: import("../../features/scheduled-orders/interfaces/processing-cycle.interface").ProcessingCycleEditRequest,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<void> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ProcessingCycles/${processingCycleId}`;

    return this.httpPut<
      import("../../features/scheduled-orders/interfaces/processing-cycle.interface").ProcessingCycleEditRequest,
      void
    >(endpoint, request, accessToken, showGlobalLoader);
  }

  /**
   * Get next occurrence date for a scheduled order
   * Used when completing/voiding cycles to show next processing date
   * Matches old QMC getScheduledOrderNextOccurenceUtc
   */
  getScheduledOrderNextOccurrence(
    scheduledOrder: ScheduledOrderListItem,
    siteId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<Date> {
    const nowUtc = new Date().toISOString();
    const endpoint =
      this.qpilotUrl +
      "/ScheduledOrders/NextOccurrenceUtc?FrequencyType=" +
      encodeURIComponent(scheduledOrder.FrequencyType) +
      "&Frequency=" +
      scheduledOrder.Frequency +
      "&FromUtc=" +
      encodeURIComponent(nowUtc) +
      "&SiteId=" +
      siteId +
      (scheduledOrder.UtcOffset
        ? "&UtcOffset=" + scheduledOrder.UtcOffset
        : "");

    return this.httpGet<Date>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get next occurrence date from a reference date
   * Used when voiding to show skipped next occurrence
   * Matches old QMC getScheduledOrderNextOccurenceUtcFromReferenceDate
   */
  getScheduledOrderNextOccurrenceFromDate(
    scheduledOrder: ScheduledOrderListItem,
    referenceDate: Date,
    siteId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<Date> {
    const endpoint =
      this.qpilotUrl +
      "/ScheduledOrders/NextOccurrenceUtc?FrequencyType=" +
      encodeURIComponent(scheduledOrder.FrequencyType) +
      "&Frequency=" +
      scheduledOrder.Frequency +
      "&FromUtc=" +
      encodeURIComponent(referenceDate.toISOString()) +
      "&SiteId=" +
      siteId +
      (scheduledOrder.UtcOffset
        ? "&UtcOffset=" + scheduledOrder.UtcOffset
        : "");

    return this.httpGet<Date>(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Update scheduled order next occurrence date
   * Portal V2 equivalent: updateScheduledOrderNextOccurrence
   * API: PUT /Sites/{siteId}/ScheduledOrders/{orderId}/NextOccurrenceUtc
   *
   * @param siteId - Site ID
   * @param orderId - Scheduled order ID
   * @param nextOccurrenceUtc - New next occurrence date
   * @param accessToken - Auth token
   * @param showGlobalLoader - Show loading spinner
   * @returns Observable with updated scheduled order
   */
  updateScheduledOrderNextOccurrence(
    siteId: number,
    orderId: number,
    nextOccurrenceUtc: Date,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<any> {
    const endpoint = `${this.qpilotUrl}/Sites/${siteId}/ScheduledOrders/${orderId}/NextOccurrenceUtc`;
    return this.httpPut<{ nextOccurrenceUtc: Date }, any>(
      endpoint,
      { nextOccurrenceUtc },
      accessToken,
      showGlobalLoader,
    );
  }

  /**
   * Build query parameters string from filter object
   */
  private buildScheduledOrdersQueryParams(
    filter: ScheduledOrdersFilter,
  ): string {
    const params = new URLSearchParams();

    // Pagination
    params.append("page", filter.page.toString());
    params.append("pageSize", filter.pageSize.toString());

    // Sorting
    if (filter.orderBy) {
      params.append("orderBy", filter.orderBy);
    }
    if (filter.order) {
      params.append("order", filter.order);
    }

    // Search
    if (filter.search && filter.search.trim()) {
      params.append("search", filter.search.trim());
    }

    // Status filter
    if (filter.status && filter.status.length > 0) {
      params.append("status", filter.status.join(","));
    }

    // Processing error codes - convert numeric codes to string enums for API
    if (filter.processingErrorCodes && filter.processingErrorCodes.length > 0) {
      const enumStrings = ProcessingErrorCodeHelper.convertCodesToEnums(
        filter.processingErrorCodes,
      );
      if (enumStrings.length > 0) {
        params.append("processingErrorCodes", enumStrings.join(","));
      }
    }

    // Date filters
    if (filter.customerCreatedFromDate) {
      params.append(
        "customerCreatedFromDate",
        filter.customerCreatedFromDate.toISOString(),
      );
    }
    if (filter.customerCreatedToDate) {
      params.append(
        "customerCreatedToDate",
        filter.customerCreatedToDate.toISOString(),
      );
    }
    if (filter.scheduledOrderCreatedFromDate) {
      params.append(
        "scheduledOrderCreatedFromDate",
        filter.scheduledOrderCreatedFromDate.toISOString(),
      );
    }
    if (filter.scheduledOrderCreatedToDate) {
      params.append(
        "scheduledOrderCreatedToDate",
        filter.scheduledOrderCreatedToDate.toISOString(),
      );
    }
    if (filter.startDate) {
      params.append("startDate", filter.startDate.toISOString());
    }
    if (filter.endDate) {
      params.append("endDate", filter.endDate.toISOString());
    }
    if (filter.lastProcessedFromDate) {
      params.append(
        "lastProcessedFromDate",
        filter.lastProcessedFromDate.toISOString(),
      );
    }
    if (filter.lastProcessedToDate) {
      params.append(
        "lastProcessedToDate",
        filter.lastProcessedToDate.toISOString(),
      );
    }

    // Additional parameters to match old QMC behavior
    if (typeof filter.offset === "number") {
      params.append("offset", filter.offset.toString());
    }
    if (typeof filter.active === "boolean") {
      params.append("active", filter.active.toString());
    }
    if (typeof filter.valid === "boolean") {
      params.append("valid", filter.valid.toString());
    }

    return params.toString();
  }

  /**
   * Transform a single API scheduled order to internal format
   */
  private transformToScheduledOrderListItem(item: any): ScheduledOrderListItem {
    return {
      Id: item.Id,
      CustomerFirstName: item.CustomerFirstName || "",
      CustomerLastName: item.CustomerLastName || "",
      CustomerEmail: item.CustomerEmail || "",
      LastProcessingCycleId: item.LastProcessingCycleId,
      LastProcessingCycle: item.LastProcessingCycle,
      Status: item.Status,
      ProcessingErrorCode: item.ProcessingErrorCode,
      ValidationChecks: item.ValidationChecks,
      LastOccurrenceUtc: item.LastOccurrenceUtc
        ? new Date(item.LastOccurrenceUtc)
        : undefined,
      NextOccurrenceUtc: item.NextOccurrenceUtc
        ? new Date(item.NextOccurrenceUtc)
        : undefined,
      UtcOffset: item.UtcOffset ?? 0,
      Cycles: item.Cycles ?? 0,
      FrequencyType: item.FrequencyType || "",
      Frequency: item.Frequency ?? 0,
      ShippingPostcode: item.ShippingPostcode,
      ShippingCountry: item.ShippingCountry,
      ShippingState: item.ShippingState,
      PreferredShippingRateOption: item.PreferredShippingRateOption,
      PaymentMethodName: item.PaymentMethod?.Type || item.PaymentMethodName,
      CurrencyIso: item.CurrencyIso || "USD",
      TotalProductQuantity:
        item.Items?.length ?? item.TotalProductQuantity ?? 0,
      Subtotal: item.Subtotal,
      LifetimeValue: item.LifetimeValue,
      IsInDunning: item.IsInDunning,
      Locked: item.Locked,
      LastEditableDate: item.LastEditableDate
        ? new Date(item.LastEditableDate)
        : undefined,
      Metadata: item.Metadata,
      IsSelected: false,
    };
  }

  /**
   * Transform old API response items to new interface
   */
  private transformToScheduledOrderListItems(
    items: any[],
  ): ScheduledOrderListItem[] {
    return items.map((item) => this.transformToScheduledOrderListItem(item));
  }

  /**
   * Get processing error code descriptions
   * This could be moved to a separate helper service later
   */
  getProcessingErrorCodeDescriptions(): Record<number, string> {
    // Based on ProcessingErrorCodesHelper from old QMC
    return {
      1001: "Payment Method Declined",
      1002: "Payment Method Expired",
      1003: "Payment Method Invalid",
      2001: "Product Not Found",
      2002: "Product Out of Stock",
      2003: "Product Discontinued",
      3001: "Order Update Failed",
      3002: "Shipping Rate Error",
      3003: "Tax Calculation Error",
      4001: "Customer Account Locked",
      4002: "Customer Address Invalid",
      5001: "General Processing Error",
    };
  }

  /**
   * Get status filter options with counts
   */
  getStatusFilterOptions(counts?: ScheduledOrderCounts) {
    return [
      {
        value: "Active",
        label: `Active${counts ? ` (${counts.Active})` : ""}`,
      },
      {
        value: "Paused",
        label: `Paused${counts ? ` (${counts.Paused})` : ""}`,
      },
      {
        value: "Failed",
        label: `Failed${counts ? ` (${counts.Failed})` : ""}`,
      },
      {
        value: "Queued",
        label: `Queued${counts ? ` (${counts.Queued})` : ""}`,
      },
      {
        value: "Processing",
        label: `Processing${counts ? ` (${counts.Processing})` : ""}`,
      },
      {
        value: "Locked",
        label: `Locked${counts ? ` (${counts.Locked})` : ""}`,
      },
      {
        value: "Deleted",
        label: `Deleted${counts ? ` (${counts.Deleted})` : ""}`,
      },
    ];
  }

  // ========== SignalR Notifications Methods ==========

  /**
   * Subscribe to scheduled order notifications via SignalR
   * @param accessToken Access token
   * @param siteId Site ID
   * @param scheduledOrderId Scheduled order ID
   * @param connectionId SignalR connection ID
   * @returns Observable for the subscription
   */
  subscribeToScheduledOrderNotifications(
    accessToken: QPilotAccessToken,
    siteId: number,
    scheduledOrderId: number,
    connectionId: string,
  ): Observable<any> {
    const endpoint = `${this.qpilotUrl}/Notifications/ScheduledOrders/${scheduledOrderId}/Subscribe/?connectionId=${connectionId}`;

    return this.httpPost<any, any>(endpoint, null, accessToken);
  }

  // ========== Non-Core Analytics Methods ==========

  /**
   * Get orders revenue summary analytics from non-core API
   * All query parameters are optional
   * @param siteId Site ID
   * @param accessToken Access token
   * @param params Optional query parameters (dateCreatedFrom, dateCreatedTo, currency)
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable with the revenue summary response
   */
  getOrdersRevenueSummary(
    siteId: number,
    accessToken: QPilotAccessToken,
    params?: import("../../features/dashboard/interfaces/revenue-analytics.interface").OrdersRevenueSummaryParams,
    showGlobalLoader: boolean = false,
  ): Observable<
    import("../../features/dashboard/interfaces/revenue-analytics.interface").OrdersRevenueSummaryResponse
  > {
    // Build query string from optional params
    const queryParams: string[] = [];
    if (params?.dateCreatedFrom) {
      queryParams.push(
        `dateCreatedFrom=${encodeURIComponent(params.dateCreatedFrom)}`,
      );
    }
    if (params?.dateCreatedTo) {
      queryParams.push(
        `dateCreatedTo=${encodeURIComponent(params.dateCreatedTo)}`,
      );
    }
    if (params?.currency) {
      queryParams.push(`currency=${encodeURIComponent(params.currency)}`);
    }

    const queryString =
      queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
    const endpoint = `${this.qpilotNonCoreApiUrl}/v1/sites/${siteId}/analytics/orders-revenue/summary${queryString}`;

    return this.httpGet<
      import("../../features/dashboard/interfaces/revenue-analytics.interface").OrdersRevenueSummaryResponse
    >(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get aggregated daily revenue analytics with current/previous period comparison
   * @param siteId Site ID
   * @param accessToken Access token
   * @param params Optional query parameters (dateCreatedFrom, dateCreatedTo, currency)
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable with the aggregated revenue data
   */
  getOrdersRevenueDailyAggregated(
    siteId: number,
    accessToken: QPilotAccessToken,
    params?: import("../../features/dashboard/interfaces/revenue-analytics.interface").OrdersRevenueDailyAggregatedParams,
    showGlobalLoader: boolean = false,
  ): Observable<
    import("../../features/dashboard/interfaces/revenue-analytics.interface").OrdersRevenueDailyAggregatedResponse
  > {
    // Build query string from optional params
    const queryParams: string[] = [];
    if (params?.dateCreatedFrom) {
      queryParams.push(
        `dateCreatedFrom=${encodeURIComponent(params.dateCreatedFrom)}`,
      );
    }
    if (params?.dateCreatedTo) {
      queryParams.push(
        `dateCreatedTo=${encodeURIComponent(params.dateCreatedTo)}`,
      );
    }
    if (params?.currency) {
      queryParams.push(`currency=${encodeURIComponent(params.currency)}`);
    }

    const queryString =
      queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
    const endpoint = `${this.qpilotNonCoreApiUrl}/v1/sites/${siteId}/analytics/orders-revenue/daily${queryString}`;

    return this.httpGet<
      import("../../features/dashboard/interfaces/revenue-analytics.interface").OrdersRevenueDailyAggregatedResponse
    >(endpoint, accessToken, showGlobalLoader);
  }

  /**
   * Get analytics status for a site from non-core API
   * @param siteId Site ID
   * @param accessToken Access token
   * @param showGlobalLoader Optional, if true shows global loader (default: false)
   * @returns Observable with the analytics status response
   */
  getAnalyticsStatus(
    siteId: number,
    accessToken: QPilotAccessToken,
    showGlobalLoader: boolean = false,
  ): Observable<
    import("../../features/dashboard/interfaces/analytics-status.interface").AnalyticsStatusResponse
  > {
    const endpoint = `${this.qpilotNonCoreApiUrl}/v1/sites/${siteId}/analytics`;

    return this.httpGet<
      import("../../features/dashboard/interfaces/analytics-status.interface").AnalyticsStatusResponse
    >(endpoint, accessToken, showGlobalLoader);
  }
}
